//Loads only those fees for the current logged in portal user
define(function() {
	const IpsModel = require('civicsBase/ipsModel');

	return IpsModel.extend({
		urlRoot: '/delegate/civics-api/api/cashiering/transaction/internalcharge/validate/'
	});
});
 